import { render } from "./List.vue?vue&type=template&id=2cadfd4e"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksCustomFields/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cadfd4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cadfd4e', __exports__)) {
    api.reload('2cadfd4e', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=2cadfd4e", () => {
    api.rerender('2cadfd4e', render)
  })

}


export default __exports__